import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import type { SupportTicketListItemResponse as SupportTicketListItemResponseType } from "@redotech/effect-api-shared/models/shopper-ai/conversation/support-ticket";
import type { EffectApiContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import {
  createSupportTicketListCollection as createSupportTicketListCollectionCore,
  fetchSingleSupportTicket as fetchSingleSupportTicketCore,
} from "@redotech/redo-support-v2/query/support-ticket-list-collection";
import type { QueryClient } from "@tanstack/react-query";
import { createMerchantSupportTicketDataSource } from "./support-ticket-data-source";

export async function fetchSingleSupportTicket(
  effectApi: EffectApiContext,
  supportTicketId: SupportTicketId,
): Promise<SupportTicketListItemResponseType> {
  return fetchSingleSupportTicketCore(
    createMerchantSupportTicketDataSource({ effectApi }).list,
    supportTicketId,
  );
}

export interface CreateSupportTicketListCollectionOptions {
  queryClient: QueryClient;
  effectApi: EffectApiContext;
}

export function createSupportTicketListCollection({
  queryClient,
  effectApi,
}: CreateSupportTicketListCollectionOptions) {
  return createSupportTicketListCollectionCore({
    queryClient,
    api: createMerchantSupportTicketDataSource({ effectApi }).list,
    onUpdateError: (supportTicketId, err) => {
      console.error("[supportTickets] PATCH failed for", supportTicketId, err);
    },
  });
}

export {
  supportTicketListQueryKeys,
  type PageLoadResult,
  type SupportTicketListCollectionWithLoader,
} from "@redotech/redo-support-v2/query/support-ticket-list-collection";
export {
  DEFAULT_SUPPORT_TICKET_PAGE_SIZE as DEFAULT_PAGE_SIZE,
  SUPPORT_TICKET_PREFETCH_PAGES_AHEAD as PREFETCH_PAGES_AHEAD,
} from "@redotech/redo-support-v2/query/support-ticket-list-requests";
